import React from 'react';
import { LocalizationContext } from './context';
export var LocalizationProvider = function (_a) {
    var children = _a.children, locale = _a.locale, translations = _a.translations;
    return (React.createElement(LocalizationContext.Provider, { value: {
            locale: locale,
            translations: translations,
        } }, children));
};
//# sourceMappingURL=provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ilenia/dist/provider.js
// module id = 581
// module chunks = 0